import { styled } from 'components/Theme/main';

export const StoreMapWrapStyled = styled.div`
    width: 100%;
    height: 100%;
`;
